import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user } = useAuth();
  if (user === undefined) return (
    <div className="flex items-center justify-center min-h-screen" style={{ background: '#1A1A1A' }}>
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#F97316] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p style={{ color: '#999999', fontFamily: 'Inter, sans-serif' }}>Loading...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/dashboard" replace />;
  return children;
}
